import { Store } from 'vuex'
import { setHttpStatusHandler } from '@/http'

export function configureHttpStatusHandler<TState>(store: Store<TState>) {
    setHttpStatusHandler(status => {
        if (status == 0) {
            store.commit('SET_AUTH', {})
            store.commit('SET_ISSERVEROUT', true)
        } else {
            store.commit('SET_ISSERVEROUT', false)
        }

        if (status == 401) {
            store.commit('SET_AUTH', {})
        }
    })
}
